import { render, staticRenderFns } from "./experts.vue?vue&type=template&id=12c2234f&scoped=true&"
import script from "./experts.vue?vue&type=script&lang=js&"
export * from "./experts.vue?vue&type=script&lang=js&"
import style0 from "./experts.vue?vue&type=style&index=0&id=12c2234f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c2234f",
  null
  
)

export default component.exports